import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export const VideoComponent = (param)=>{
    let { videoSrc , posterSrc  } = param;
    return /*#__PURE__*/ _jsx("video", {
        width: "100%",
        controls: true,
        poster: posterSrc,
        children: /*#__PURE__*/ _jsx("source", {
            src: videoSrc,
            type: "video/mp4"
        })
    });
};
